module.exports = ".leftlinks:hover{\n    color:#3E68AC;\n    text-decoration: underline !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/faq/faq.component.css
// module id = ./src/app/shared/faq/faq.component.css
// module chunks = main